import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
// import GridItem from "components/Grid/GridItem.js";
import GridContainer from "../../Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Card from "components/Card/Card.js";
// import CardHeader from "components/Card/CardHeader.js";
// import CardBody from "components/Card/CardBody.js";

const styles = {
  test: {
    alignItems: "center",
  },
};

const useStyles = makeStyles(styles);

export default function TableList() {
  const classes = useStyles();
  return (
    <GridContainer className={classes.test}>
      <h1>List table</h1>
    </GridContainer>
  );
}
